export default class AutoCompleteInput extends Backbone.View {
    template({ className, id, label }) {
        return `
            <div class="ui-widget autoComplete ${className}">
                <input id="${id}" aria-label="${label}" type="search" name="search">
                <label class="inputLabel" for="${id}" title="${label}">${label}</label>
                <i class="icon-down-arrow" aria-hidden="true"></i>
                <div class="results"><div>
            </div>`;
    }

    constructor({
        className,
        id,
        label,
        fieldList,
        defaultField,
        selectedEvent,
    }) {
        super(...arguments);

        _.extend(this, arguments[0]);

        this.defaultField = defaultField || '';
        this.selectedEvent = selectedEvent || (() => {});
    }

    render() {
        this.$el.empty().append(this.template(this));

        this.$input = this.$el.find('input');

        if (this.defaultField) {
            this.lastSelected = this.defaultField;
            this.$input.val(this.defaultField);
            this.$el.find('.inputLabel');
            this.$el.find('.autoComplete').addClass('focused');
        }

        this.$input
            .autocomplete({
                source: this.fieldList,
                appendTo: this.$el.find('.results'),
                minLength: 0,
            })
            .autocomplete('widget')
            .addClass('fixed-height');

        this._attachEvents();

        return this;
    }

    _attachEvents() {
        this.$input.on('focus click', () => {
            this.$input.val('');
            this.$input.autocomplete('search', '');
        });

        this.$input.on('autocompleteselect', (event, target) => {
            this.$input.val(target.item.label);
            this.selectedEvent(target.item.label);
            this.lastSelected = target.item.label;
        });

        this.$el.find('.icon-down-arrow').on('click', () => {
            this.$input.click().focus();
        });

        this.$input.on('focus', () => {
            this.$el.find('.autoComplete').find('.inputLabel');
            this.$el.find('.autoComplete').addClass('focused');
        });

        this.$input.on('blur', () => {
            if (this.lastSelected) {
                this.$input.val(this.lastSelected);
            }

            if (!this.$input.val()) {
                this.$el.find('.inputLabel');
                this.$el.find('.autoComplete').removeClass('focused');
            }
        });
    }
}
